import { FC } from 'react';
import { FormControl, FormHelperText, InputLabel, InputProps, OutlinedInput } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

type IFormInputProps = {
  name: string;
  label: string;
} & InputProps;

const FormInput: FC<IFormInputProps> = ({ id, name, label, ...otherProps }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      control={control}
      defaultValue=""
      name={name}
      render={({ field }) => (
        <FormControl fullWidth sx={{ mt: 4, mb: 2 }}>
          <InputLabel htmlFor={id}>{label}</InputLabel>
          <OutlinedInput
            notched
            fullWidth
            id={id}
            label={label}
            error={!!errors[name]}
            {...field}
            {...otherProps}
          />
          <FormHelperText error={!!errors[name]}>
            {errors[name] ? errors[name].message : ''}
          </FormHelperText>
        </FormControl>
      )}
    />
  );
};

export default FormInput;
